import React from 'react';
export function AuthorSection() {
  return <section className="bg-gradient-to-b from-[#5b2580] to-[#4a1d6a] px-4 py-14 text-white" data-id="element-15" data-mp="1ej4gqy30kqml">
      <div className="mx-auto max-w-md text-center" data-id="element-16" data-mp="saxv7cga6fgk">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-pink" data-id="element-17" data-mp="178q7zwug0pr2">
          ¿Quién creó este sistema?
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold" data-id="element-18" data-mp="12aoml59joecf">Conoce a la Dra. Karito</h2>

        <img src="https://cdn.magicpatterns.com/patterns/generated-images/accf96bf-bccd-40c8-9f60-c1413e951900.jpg" alt="Dra. Karito, terapeuta y formadora" className="mx-auto mt-6 h-52 w-52 rounded-3xl object-cover shadow-xl ring-4 ring-pink/30" loading="lazy" data-id="element-19" data-mp="ekuaipx1utt8" />

        <div className="mt-6 space-y-3 text-left text-[15px] leading-relaxed text-white/85" data-id="element-20" data-mp="jhb2jv7ddsbl">
          <p data-id="element-21" data-mp="3rxe6pqz9wyv6">
            Después de acompañar a cientos de pacientes y formar terapeutas, la Dra. Karito
            identificó un problema que se repetía constantemente:
          </p>
          <p className="font-semibold text-white" data-id="element-22" data-mp="2vmsn4kosmeiv">
            Los terapeutas no necesitaban más teoría. Necesitaban una herramienta que les ayudara a
            saber qué preguntar exactamente cuando estaban frente al paciente.
          </p>
          <p data-id="element-23" data-mp="34ii1i9rtq8mr">
            Así nació <span className="font-bold text-pink" data-id="element-24" data-mp="39ez0jz0ka7em">El Oráculo de las Preguntas.</span> No
            como un libro para estudiar, sino como un sistema práctico de consulta diseñado para
            acompañarte antes, durante y después de cada sesión.
          </p>
          <p data-id="element-25" data-mp="2gsnptvj8qq43">
            Hoy ese mismo sistema puede convertirse en uno de tus recursos de trabajo más valiosos.
          </p>
        </div>
      </div>
    </section>;
}